/**
 * 压缩图片文件操作的状态管理
 *
 */

const state = {
    files: [],

    //当前文件操作
    file_action: {
        state: false,
        clientX: 0,
        clientY: 0
    },

    //创建操作
    create_file_action: {
        state: false,
        title: '',
    },

    //重命名操作
    rename_file_action: {
        state: false,
        title: '',
    },

    share_file_action: {
        state: false,
    },

    //移动或复制弹出框
    move_file_action: {
        state: false,

        folder_list_state: false,
        folder: {
            id: 0
        },


        event_but: true,
    },

    //删除操作
    delete_file_action: {
        state: false,
    },


}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
    'update_files': (state, data) => {
        state.files = data;
    },
    'update_file_action': (state, data) => {
        for (let k in data) {
            state.file_action[k] = data[k]
        }
    },

    'update_rename_file_action': (state, data) => {
        for (let k in data) {
            state.rename_file_action[k] = data[k]
        }
    },

    'update_create_file_action': (state, data) => {
        for (let k in data) {
            state.create_file_action[k] = data[k]
        }
    },

    'update_share_file_action': (state, data) => {
        for (let k in data) {
            state.share_file_action[k] = data[k]
        }
    },

    //复制移动(非拖拽)操作
    'update_move_file_action':(state,data)=>{
        for (let k in data) {
            state.move_file_action[k] = data[k]
        }
    },

    'update_delete_file_action': (state, data) => {
        for (let k in data) {
            state.delete_file_action[k] = data[k]
        }
    },


    'dialog_close': (state) => {
        state.file_action.state = false;
        state.rename_file_action.state = false;
        state.share_file_action.state = false;
        state.delete_file_action.state = false;
        state.create_file_action.state = false;
        state.move_file_action.state = false;
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
